import { createElement } from 'react';
import { getCurrentUser } from '../../services/CurrentUser';
import { attachProfileInfo } from '../../services/ProfileInfo';

function PrepareUser(component) {
    return props => {
        const { user, useFirstName, ...otherProps } = props;
        const realUser = attachProfileInfo(getCurrentUser(), user, useFirstName);
        const passedProps = { user: realUser, useFirstName, ...otherProps };
        return createElement(component, passedProps);
    };
}

export default PrepareUser;
